import axios from "../../axios";

const getAppliedPayments = async (payment_id) => {
  try {
    const { data } = await axios.get(`/payments/applied/${payment_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getActiveGateways = async () => {
  try {
    const { data } = await axios.get("/integrations/type/cc");
    return data;
  } catch (e) {
    return null;
  }
}

const getTerminalStatus = async (integration_id, terminal_id) => {
  try {
    const { data } = await axios.get(`/payments/terminal/status?integration_id=${integration_id}&terminal_id=${terminal_id}`);
    return data;
  } catch (e) {
    return null;
  }
}

const getCCSettings = async () => {
  try {
    const { data } = await axios.get("/settings/cc/general");
    return data;
  } catch (e) {
    return null;
  }
}

const processPayment = async ({ packet }) => {
  let url = packet?.entry !== "manual" ? "/payments/process" : "/payments";
  try {
    if (packet?.terminal_id){ 
      url = "/payments/terminal";
    } else if (packet?.magstripe) {
      url = "/payments/magstripe";
    }

    const { data } = await axios.post(`${url}`, { ...packet }, { timeout: 30000 });
    return data;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};


const getAvailablePaymentsByCustomer = async (customer_id) => {
  try {
    const { data } = await axios.get(`/payments/available/${customer_id}?applied_status[$ne]=applied`);
    return data;
  } catch (e) {
    throw e;
  }
};

const applyPaymentsToInvoice = async (dataPacket) => {
  console.log(dataPacket, "dataPacket");
  try {
    const { data } = await axios.post(`/payments/apply`, dataPacket);
    return data;
  } catch (e) {
    throw e;
  }
}

const removeAppliedPayment = async (applied_payment_id) => {
  try {
    const { data } = await axios.delete(`/payments/applied/${applied_payment_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

const getPaymentStats = async (fq) => {
  try {
    const { data } = await axios.get(`/payments/stats?${fq}`);
    return data;
  } catch (e) {
    throw e;
  }
};

export { getAppliedPayments, processPayment, removeAppliedPayment, getAvailablePaymentsByCustomer, applyPaymentsToInvoice, getActiveGateways, getPaymentStats, getCCSettings, getTerminalStatus };